import { render, staticRenderFns } from "./InstrumentSelector.vue?vue&type=template&id=3515d134"
import script from "./InstrumentSelector.vue?vue&type=script&lang=js"
export * from "./InstrumentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports